
import ImagesLoaded from './images-loaded';

export {
	ImagesLoaded
};

export default {
	ImagesLoaded
};



// WEBPACK FOOTER //
// ./src/vue/directives/index.js